import React from 'react';

const CustomExpandIcon: React.FC = () => (
  <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.44422 8L-1.27144e-07 6.54564L6.5 1.04509e-06L13 6.54564L11.5558 8L6.5 2.90872L1.44422 8Z" fill="#7B726C"/>
  </svg>

);

export default React.memo(CustomExpandIcon);